import moment from 'moment'
import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async getDefaultStatistics ({ rootGetters, commit }) {
    storeClient.get(`/stores/${rootGetters.storeId}/statistics`, {
      params: {
        s: moment().format('YYYY-MM-DD'),
        u: 'businessHours'
      }
    }).then(({ data: todayStatistics }) =>
      commit(types.SET_STATISTICS, { todayStatistics })
    ).catch(e =>
      console.error(e)
    )

    const yesterdayString = moment().add(-1, 'day').format('YYYY-MM-DD')
    storeClient.get(`/stores/${rootGetters.storeId}/statistics`, {
      params: {
        s: yesterdayString,
        e: yesterdayString,
        u: 'day'
      }
    }).then(({ data: yesterdayStatistics }) =>
      commit(types.SET_STATISTICS, { yesterdayStatistics })
    ).catch(e =>
      console.error(e)
    )

    storeClient.get(`/stores/${rootGetters.storeId}/statistics`, {
      params: {
        s: moment().add(-7, 'day').format('YYYY-MM-DD')
      }
    }).then(({ data: lastWeekStatistics }) =>
      commit(types.SET_STATISTICS, { lastWeekStatistics })
    ).catch(e =>
      console.error(e)
    )
  },
  async getCustomStatistics ({ state, rootGetters, commit }) {
    try {
      const params = {
        s: state.startDate,
        e: state.endDate,
        u: state.searchUnit,
        v: state.variation
      }
      const customStatisticsPromise = storeClient.get(`/stores/${rootGetters.storeId}/statistics`, { params })
      const customForHereStatisticsPromise = storeClient.get(`/stores/${rootGetters.storeId}/statistics`, {
        params: Object.assign({ t: 'forHere' }, params)
      })
      const { data: customStatistics } = await customStatisticsPromise
      const { data: customForHereStatistics } = await customForHereStatisticsPromise
      commit(types.SET_STATISTICS, { customStatistics })
      commit(types.SET_STATISTICS, { customForHereStatistics })
    } catch (e) {
      console.error(e)
    }
  },
  setSearchRange ({ commit }, { startDate, endDate }) {
    commit(types.SET_SEARCH_RANGE, { startDate, endDate })
  },
  setSearchUnit ({ commit }, unit) {
    commit(types.SET_UNIT, unit)
  },
  async getStoreHotSaleReportData ({ rootGetters, commit }, { startDateString, endDateString, index }) {
    try {
      const { data: storeHotSale } = await storeClient.get(`/stores/${rootGetters.storeId}/storeHotSale?s=${startDateString}&e=${endDateString}`)
      storeHotSale.startDateString = startDateString
      storeHotSale.endDateString = endDateString
      storeHotSale.index = index
      commit(types.SET_STORE_HOT_SALE_REPORT_DATA, storeHotSale)
    } catch (e) {
      console.error(e)
    }
  },
  clearStoreHotSaleReportData ({ commit }) {
    commit(types.CLEAR_STORE_HOT_SALE_REPORT_DATA)
  },
  getStoreHotSale ({ rootGetters, commit }, { startDateString, endDateString }) {
    // 先清空 上一次的 storeHotSale
    commit(types.SET_STORE_HOT_SALE, null)
    storeClient
      .get(`/stores/${rootGetters.storeId}/storeHotSale?s=${startDateString}&e=${endDateString}`)
      .then(({ data: storeHotSale }) => {
        storeHotSale.startDateString = startDateString
        storeHotSale.endDateString = endDateString
        commit(types.SET_STORE_HOT_SALE, storeHotSale)
      })
      .catch(e => console.error(e))
  }
}
